import { EColors } from 'src/config/enums';

export type TCircle = {
    cx: string | number;
    cy: string | number;
    r: string | number;
    transform?: string;
};
export type TEllipse = {
    cx: string | number;
    cy: string | number;
    rx: string | number;
    ry?: string | number;
};
export type TRectangle = { width: string | number; height: string | number };

export type Icon = {
    title?: string;
    viewBox: string;
    items: SVGItem[];
};

export type SVGItem = {
    tag: string;
    fill?: string;
    stroke?: string;
    value: string | TCircle | TEllipse | TRectangle | SVGItem[];
    attrs?: any;
};

export const ICONS: {
    [key: string]: Icon;
} = {
    ouronyx: {
        title: 'Ouronyx',
        viewBox: '0 0 92 25',
        items: [
            {
                tag: 'path',
                value: 'M22.9239286,12.5 C22.9239286,6.25 19.3452296,0.401403061 12.499949,0.401403061 C5.62494898,0.401403061 2.07609694,6.25 2.07609694,12.5 C2.07609694,18.7797194 5.62494898,24.5985969 12.499949,24.5985969 C19.3452296,24.5985969 22.9239286,18.7797194 22.9239286,12.5 M-5.10204082e-05,12.5 C-5.10204082e-05,5.625 5.29765306,0 12.499949,0 C19.6726531,0 24.999949,5.625 24.999949,12.5 C24.999949,19.4047194 19.6726531,25 12.499949,25 C5.29765306,25 -5.10204082e-05,19.4047194 -5.10204082e-05,12.5'
            },
            {
                tag: 'path',
                value: 'M15.8896151,0.806451613 C16.1081893,0.806451613 17.658867,1.70587152 17.6477068,1.93840818 C17.530287,4.36366811 17.530287,4.63755304 17.530287,6.11723978 L17.530287,14.3784237 C17.530287,21.5775764 18.2590259,24.4546326 22.6360901,24.4546326 C27.0408174,24.4546326 29.2300025,21.872578 29.2300025,14.3784237 L29.2300025,6.11723978 C29.2300025,4.55346556 29.2300025,3.55023238 29.0914495,0.806451613 L29.8387097,0.806451613 C29.7002754,3.55023238 29.7002754,4.55346556 29.7002754,6.11723978 L29.7002754,14.3784237 C29.7002754,22.1086552 27.1792517,25 22.5806452,25 C17.9820386,25 15.4610149,22.6986585 15.4610149,14.3784237 L15.4610149,6.11723978 C15.4610149,4.55346556 15.4610149,3.55023238 15.3225806,0.806451613 L15.8896151,0.806451613 Z'
            },
            {
                tag: 'path',
                value: 'M35.8797979,12.9827365 C39.9241099,12.9827365 43.039318,11.915404 43.039318,7.09179808 C43.039318,2.26806686 39.9241099,1.20073442 35.8797979,1.20073442 L34.4233437,1.20073442 L34.4233437,12.9827365 L35.8797979,12.9827365 Z M49.1935484,23.8614087 L48.918038,24.1935484 C44.8134499,24.1935484 42.2270149,22.4103177 40.8084596,18.7561543 C39.0881362,14.3125482 38.0528379,13.3770193 34.6725965,13.3770193 L34.483361,13.3770193 L34.483361,18.9314328 C34.483361,20.4810006 34.483361,21.474914 34.6343096,24.1935484 L32.2580645,24.1935484 C32.4090132,21.474914 32.4090132,20.4810006 32.4090132,18.9314328 L32.4090132,6.06856718 C32.4090132,4.51912472 32.4090132,3.52521132 32.2580645,0.806451613 L35.8797979,0.806451613 C40.8294139,0.806451613 45.0246746,2.1219805 45.0246746,7.09179808 C45.0246746,11.5060866 41.7047092,13.0263368 37.5095779,13.3186348 C39.7430232,13.7863367 41.6745712,15.0726734 42.9723159,18.4929232 C44.6020959,22.8196351 46.2658944,23.8614087 49.1935484,23.8614087 L49.1935484,23.8614087 Z      '
            },
            {
                tag: 'path',
                value: 'M55.1820441,12.5 C55.1820441,6.25 51.6033451,0.401403061 44.7581921,0.401403061 C37.8830645,0.401403061 34.3342125,6.25 34.3342125,12.5 C34.3342125,18.7797194 37.8830645,24.5985969 44.7581921,24.5985969 C51.6033451,24.5985969 55.1820441,18.7797194 55.1820441,12.5 M32.2580645,12.5 C32.2580645,5.625 37.5557686,0 44.7581921,0 C51.9307686,0 57.2580645,5.625 57.2580645,12.5 C57.2580645,18.3552296 53.4271972,23.2688776 47.8886768,24.6272959 C46.8959472,24.8706633 45.8483706,25 44.7581921,25 C37.5557686,25 32.2580645,19.4047194 32.2580645,12.5'
            },
            {
                tag: 'path',
                value: 'M74.810521,13.7863367 L74.810521,18.9314328 C74.810521,20.4810006 74.810521,21.474914 74.958925,24.1935484 L72.7407486,24.1935484 C72.8890255,21.474914 72.8890255,20.4810006 72.8890255,18.9314328 L72.8890255,13.7863367 L67.1621805,3.55452882 C66.5391887,2.443596 66.1831207,1.94657665 65.3225806,0.806451613 L67.837438,0.806451613 C68.2232631,1.94657665 68.5793311,2.47278821 69.2023229,3.55452882 L74.5882328,13.2750345 L80.1370438,3.45254401 C80.7897927,2.31241897 81.0568437,1.94657665 81.6207028,0.806451613 L82.2580645,0.806451613 C81.4866686,1.94657665 81.1899877,2.47278821 80.5964987,3.52521132 L74.810521,13.7863367 Z'
            },
            {
                tag: 'path',
                value: 'M89.3852035,21.5332984 L84.2149478,12.3245961 L89.3852035,3.4668269 C89.9971169,2.4142785 90.1806779,1.94657665 91.0372518,0.806451613 L90.3186108,0.806451613 C89.7680591,1.94657665 89.4925866,2.31241897 88.8808043,3.3647168 L83.8941095,11.8426114 L80.4139255,5.49925639 C80.3224073,5.6262989 80.231938,5.75171265 80.1469755,5.88176208 C80.0957095,5.98712968 78.8225834,7.89151436 78.753617,7.98911407 L82.2494036,14.3749419 L78.2955013,21.4314389 C77.6835879,22.4837367 77.4389274,23.0535486 76.6129032,24.1935484 L77.3314131,24.1935484 C77.9127768,23.0535486 78.1881182,22.5857215 78.8000316,21.5332984 L82.6542866,14.8244769 L86.3699531,21.5332984 C86.9511856,22.5857215 87.1652963,23.0535486 87.6548795,24.1935484 L91.1290323,24.1935484 C90.2112276,23.0535486 89.9665671,22.5857215 89.3852035,21.5332984'
            },
            {
                tag: 'path',
                value: 'M64.3673068,6.06856718 C64.3673068,4.51912472 64.3673068,3.52508603 64.516129,0.806451613 L63.7127954,0.806451613 C63.8617452,3.52508603 63.8617452,4.51912472 63.8617452,6.06856718 L63.8617452,23.1119331 L48.4642612,0.922719309 L47.6018325,0.806451613 C47.6347623,1.40858798 47.6706277,1.92552819 47.7064931,2.38295638 C47.7216817,2.57752937 47.729595,2.77210235 47.729595,2.96730178 L47.729595,12.2553116 C47.729595,13.8046288 47.729595,18.0614297 47.5806452,20.7801894 L48.3839788,20.7801894 C48.235029,18.0614297 48.235029,13.8046288 48.235029,12.2553116 L48.2900396,4.26128106 L62.5288546,24.1935484 L64.516129,24.1935484 C64.3673068,21.474914 64.3673068,20.4808753 64.3673068,18.9314328 L64.3673068,6.06856718 Z'
            }
        ]
    },
    'ouronyx-icon': {
        title: 'Ouronyx',
        viewBox: '0 0 56 76',
        items: [
            {
                tag: 'path',
                value: 'M42.9140752,47.3580522 C42.6811564,47.5761105 42.4467053,47.7903567 42.2053585,47.9992657 C38.4855536,51.2320187 35.0584296,52.1034896 30.8,52.3802559 L30.8,27.1243733 C30.8,25.5720419 30.8,24.2309068 30.821453,22.7746431 C30.8306472,22.115131 30.8444385,21.4304583 30.863593,20.7069011 C30.8743195,20.4941799 30.8827475,20.2799337 30.8827475,20.06645 C30.8896431,13.726747 32.7805758,8.89439121 37.0175523,4.39979714 C37.2481726,4.1542909 37.3791894,4.02925046 37.4542751,4.02925046 C37.5232313,4.02925046 37.6458201,4.07118475 37.7316323,4.10320731 C45.9527459,7.11256486 50.12,14.7575682 50.12,26.8262585 C50.12,30.9655547 49.4174128,41.2524187 42.9140752,47.3580522 M38.4977536,0.692477698 L38.3096314,0.618419995 C38.0366248,0.509242144 37.6619099,0.360363256 37.2757241,0.234388813 C36.7220637,0.0526802218 34.8813721,0.0412279997 34.2489451,0.608494736 C30.6845649,3.78076027 27.9919704,7.87683838 26.4602275,12.4584907 C26.4074615,12.6234027 25.1670786,16.5408262 25.1892556,20.1620188 C25.1999618,21.8928313 25.1793142,23.0945512 25.1586666,24.2611508 C25.1441369,25.1383911 25.1296071,25.9843285 25.1296071,26.9989954 L25.1296071,52.2916097 C10.9760887,51.2861046 5.91896653,38.4481636 5.91896653,26.687495 C5.91896653,14.5221811 10.8912043,5.65816122 19.5593549,2.36831954 L20.2651955,2.10033754 L19.3888214,0 L18.7426293,0.216828739 C7.53253492,3.97544804 0,14.6130354 0,26.687495 C0,34.1215141 2.46394188,40.7317367 7.12493684,45.8035442 C11.6658701,50.7455598 17.8853733,53.7674194 25.1296071,54.5545688 L25.1296071,61.2556457 C25.1296071,65.3227116 25.1296071,68.0094029 24.7411271,75.2304107 L24.6990673,76 L31.2114599,76 L31.1701648,75.2304107 C30.7809201,68.0094029 30.7809201,65.3227116 30.7809201,61.2556457 L30.7809201,54.5560958 C35.0021986,54.1041148 40.968578,52.6687696 46.0631717,48.4619867 C46.3155307,48.2535562 46.5633014,48.0397814 46.8072485,47.8229527 C52.6489779,42.6335691 56,34.930041 56,26.687495 C56,15.0390581 49.1304811,4.83589167 38.4977536,0.692477698'
            }
        ]
    },
    'arrow-1': {
        title: 'arrow',
        viewBox: '0 0 451.846 451.847',
        items: [
            {
                tag: 'path',
                value: `M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
		L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
		c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z`
            }
        ]
    },
    'arrow-2': {
        title: 'arrow',
        viewBox: '0 0 24 10',
        items: [
            {
                tag: 'path',
                value: `M19.7973927,0.611121778 C19.6507652,0.462959407 19.4186031,0.462959407 19.2841848,0.611121778 C19.1375573,0.759260517 19.1375573,0.993839122 19.2841848,1.12964281 L22.2535728,4.12963543 L0.866580425,4.12963543 C0.658860094,4.12963543 0.5,4.29010922 0.5,4.5 C0.5,4.70987897 0.658860094,4.87037639 0.866580425,4.87037639 L22.2535728,4.87037639 L19.2841848,7.870369 C19.1375573,8.01853137 19.1375573,8.25306272 19.2841848,8.38886641 C19.3575102,8.46294759 19.4552541,8.5 19.5408121,8.5 C19.6263234,8.5 19.7240906,8.46294759 19.7973927,8.38886641 L23.3900118,4.75926642 C23.5366627,4.61110405 23.5366627,4.38888413 23.3900118,4.24074539 L19.7973927,0.611121778 Z`
            }
        ]
    },
    'arrow-3': {
        title: 'arrow',
        viewBox: '0 0 11 10',
        items: [
            {
                tag: 'path',
                value: 'M10.8672795,4.67593174 L6.53213683,0.138902222 C6.35520433,-0.0463007407 6.07505885,-0.0463007407 5.91285897,0.138902222 C5.73592647,0.324075647 5.73592647,0.617298902 5.91285897,0.787053515 L9.49596085,4.53704428 L0.442345365,4.53704428 C0.19169334,4.53704428 0,4.73763652 0,5 C0,5.26234871 0.19169334,5.46297048 0.442345365,5.46297048 L9.49596085,5.46297048 L5.91285897,9.21296125 C5.73592647,9.39816422 5.73592647,9.6913284 5.91285897,9.86108301 C6.00133933,9.95368449 6.11928492,10 6.22252612,10 C6.32571088,10 6.44368469,9.95368449 6.53213683,9.86108301 L10.8672795,5.32408303 C11.0442402,5.13888007 11.0442402,4.86110516 10.8672795,4.67593174'
            }
        ]
    },
    triangle: {
        title: 'arrow',
        viewBox: '0 0 100 100',
        items: [
            {
                tag: 'polygon',
                value: '50 15, 100 100, 0 100'
            }
        ]
    },
    pointer: {
        viewBox: '0 0 14 18',
        items: [
            {
                tag: 'path',
                value: 'M6.84850596,9.93554663 C4.90005667,9.93554663 3.31449379,8.37428196 3.31449379,6.45569202 C3.31449379,4.53710207 4.90005667,2.97583741 6.84850596,2.97583741 C8.79695524,2.97583741 10.3825181,4.53710207 10.3825181,6.45569202 C10.3825181,8.37428196 8.79695524,9.93554663 6.84850596,9.93554663 M13.0912287,4.40944567 C12.4843319,2.47823255 10.8888767,0.906763327 8.92764145,0.30913389 C6.85187069,-0.324045851 4.64329394,0.0278458356 2.95756297,1.25093533 C1.28421422,2.46557624 0.285326087,4.41136731 0.285326087,6.45569202 C0.285326087,7.8660087 0.738420962,9.2058874 1.59531738,10.3302445 L6.84850596,16.9634409 L12.1017282,10.3297475 C13.384095,8.64616062 13.7449626,6.48822734 13.0912287,4.40944567'
            }
        ]
    },
    instagram: {
        viewBox: '0 0 23.691 23.691',
        items: [
            {
                tag: 'path',
                attrs: {
                    transform: 'translate(-15 -15)'
                },
                value: 'M31.438,16.934a5.318,5.318,0,0,1,5.318,5.318v9.186a5.318,5.318,0,0,1-5.318,5.318H22.252a5.318,5.318,0,0,1-5.318-5.318V22.252a5.318,5.318,0,0,1,5.318-5.318h9.186m0-1.934H22.252A7.274,7.274,0,0,0,15,22.252v9.186a7.274,7.274,0,0,0,7.252,7.252h9.186a7.274,7.274,0,0,0,7.252-7.252V22.252A7.274,7.274,0,0,0,31.438,15Z'
            },
            {
                tag: 'path',
                attrs: {
                    transform: 'translate(-67.631 -27.89)'
                },
                value: 'M85.8,32a1.385,1.385,0,1,0,1.385,1.385A1.385,1.385,0,0,0,85.8,32Z'
            },
            {
                tag: 'path',
                attrs: {
                    transform: 'translate(-32.925 -32.796)'
                },
                value: 'M44.836,40.4a4.274,4.274,0,1,1-4.272,4.272A4.274,4.274,0,0,1,44.836,40.4m0-1.934a6.208,6.208,0,1,0,4.4,1.813,6.208,6.208,0,0,0-4.4-1.813Z'
            }
        ]
    },
    twitter: {
        viewBox: '0 0 24 20',
        items: [
            {
                tag: 'path',
                value: 'M23.7102849,2.25969231 C22.8285587,2.64291498 21.8890386,2.89692848 20.9095075,3.02026451 C21.9171946,2.42414035 22.686297,1.48737382 23.0478788,0.358261808 C22.1083588,0.913273954 21.0710338,1.30530634 19.9655418,1.52408097 C19.0734423,0.582909582 17.8019783,-4.54747351e-13 16.4149266,-4.54747351e-13 C13.7238093,-4.54747351e-13 11.557282,2.16425371 11.557282,4.81744669 C11.557282,5.19920108 11.5898836,5.5662726 11.6699058,5.9157247 C7.62878416,5.72044265 4.05297682,3.80139271 1.65082859,0.878035088 C1.23145292,1.59896356 0.985458716,2.42414035 0.985458716,3.31245344 C0.985458716,4.98042645 1.85236601,6.45899055 3.14457653,7.31500135 C2.36361902,7.30031849 1.59748044,7.07567072 0.948411395,6.72181377 C0.948411395,6.73649663 0.948411395,6.75558435 0.948411395,6.77467206 C0.948411395,9.11512011 2.63332352,11.0591309 4.84282569,11.5069582 C4.44716031,11.614143 4.0159295,11.6655331 3.56839788,11.6655331 C3.25720039,11.6655331 2.94303911,11.6479136 2.64814244,11.583309 C3.27794689,13.4906127 5.06510961,14.8928259 7.19014389,14.9383428 C5.53635152,16.2201565 3.43650942,16.992475 1.16328585,16.992475 C0.764656688,16.992475 0.382328344,16.9748556 0,16.9264022 C2.15319025,18.3021862 4.70500966,19.0877193 7.4568846,19.0877193 C16.4015896,19.0877193 21.2918358,11.7462888 21.2918358,5.38273684 C21.2918358,5.16983536 21.2844264,4.9642753 21.2740531,4.76018354 C22.2387653,4.08183536 23.0493607,3.23463428 23.7102849,2.25969231'
            }
        ]
    },
    youtube: {
        viewBox: '0 0 32.95 22.891',
        items: [
            {
                tag: 'path',
                attrs: {
                    transform: 'translate(-9 -25.79)'
                },
                value: 'M25.475,27.737c.069,0,6.866,0,11.353.324l.2.018a2.618,2.618,0,0,1,1.881.773h0a5.151,5.151,0,0,1,.758,2.118,46.729,46.729,0,0,1,.3,5.005v2.468a46.973,46.973,0,0,1-.3,5.008,5.045,5.045,0,0,1-.755,2.1h0a2.656,2.656,0,0,1-1.878.773l-.2.021c-4.409.3-11.05.33-11.35.33-.344,0-8.387-.081-10.954-.3-.153-.024-.3-.045-.473-.063a3.121,3.121,0,0,1-2.016-.752h0a5.1,5.1,0,0,1-.755-2.112,46.73,46.73,0,0,1-.3-5.005V36a46.966,46.966,0,0,1,.3-5.005,5.17,5.17,0,0,1,.758-2.118h0a2.654,2.654,0,0,1,1.881-.773l.2-.018c4.493-.321,11.284-.324,11.35-.324h.009m0-1.947h0s-6.917,0-11.527.33a4.724,4.724,0,0,0-3.3,1.375,7.02,7.02,0,0,0-1.309,3.232A48.6,48.6,0,0,0,9,36v2.468a48.583,48.583,0,0,0,.33,5.269,6.966,6.966,0,0,0,1.309,3.229,5.659,5.659,0,0,0,3.634,1.393c2.636.249,11.2.326,11.2.326s6.923,0,11.536-.338a4.726,4.726,0,0,0,3.3-1.378,7,7,0,0,0,1.309-3.229,48.605,48.605,0,0,0,.335-5.269V36a48.609,48.609,0,0,0-.33-5.269A6.984,6.984,0,0,0,40.312,27.5a4.724,4.724,0,0,0-3.3-1.375c-4.619-.332-11.542-.332-11.542-.332Z'
            },
            {
                tag: 'path',
                attrs: {
                    transform: 'translate(-40.611 -41.074)'
                },
                value: 'M54.13,47.61v9.819l8.384-4.91Z'
            }
        ]
    },
    linkedin: {
        viewBox: '0 0 24.177 24.174',
        items: [
            {
                tag: 'path',
                attrs: {
                    transform: 'translate(-14 -14)'
                },
                value: 'M36.262,15.571a.341.341,0,0,1,.341.341V36.265a.341.341,0,0,1-.341.341H15.912a.341.341,0,0,1-.341-.341V15.912a.341.341,0,0,1,.341-.341H36.264m0-1.571H15.912A1.912,1.912,0,0,0,14,15.912V36.265a1.912,1.912,0,0,0,1.912,1.91H36.264a1.912,1.912,0,0,0,1.912-1.912V15.912A1.912,1.912,0,0,0,36.262,14Z'
            },
            {
                tag: 'path',
                attrs: {
                    transform: 'translate(-45.089 -41.601)'
                },
                value: 'M60.374,50.4c-2.43,0-2.473,1.4-2.473,1.5V50.4H55V60.488h2.9V54.73a1.316,1.316,0,0,1,1.506-1.417A1.339,1.339,0,0,1,60.768,54.7v5.8h2.869V54.215C63.637,51.234,62.011,50.4,60.374,50.4Z'
            },
            {
                tag: 'rect',
                attrs: {
                    transform: 'translate(5.625 8.799)'
                },
                value: {
                    width: '2.836',
                    height: '10.088'
                }
            },
            {
                tag: 'ellipse',
                attrs: {
                    transform: 'translate(5.625 5.287)'
                },
                value: {
                    cx: '1.417',
                    cy: '1.417',
                    rx: '1.417',
                    ry: '1.417'
                }
            }
        ]
    },
    facebook: {
        viewBox: '0 0 15.48 26.174',
        items: [
            {
                tag: 'path',
                fill: 'none',
                attrs: {
                    transform: 'translate(-36.11 -13)',
                    stroke: 'currentColor',
                    strokeMiterlimit: '10',
                    strokeWidth: '2'
                },
                value: 'M41.116,19.865v3.65H37.11v4.506h4.006V38.174h4.741V28.021H49.9l.483-4.5H45.856V19.865a1.549,1.549,0,0,1,.725-1.165,6.469,6.469,0,0,1,2.212-.375h1.8V14.242A22.544,22.544,0,0,0,47.766,14C40.978,14,41.116,19.865,41.116,19.865Z'
            }
        ]
    },
    'video-play-button': {
        viewBox: '0 0 157 157',
        items: [
            {
                tag: 'g',
                attrs: {
                    transform: 'translate(-962 -312)'
                },
                value: [
                    {
                        tag: 'g',
                        attrs: {
                            transform: 'translate(1080.5 356) rotate(90)'
                        },
                        value: [
                            {
                                tag: 'path',
                                attrs: {
                                    stroke: 'none'
                                },
                                fill: EColors.White,
                                value: 'M 68.13573455810547 59.5 L 0.8642629981040955 59.5 L 34.5 1.003066062927246 L 68.13573455810547 59.5 Z'
                            },
                            {
                                tag: 'path',
                                attrs: {
                                    stroke: 'none'
                                },
                                fill: EColors.DoveGrey,
                                value: 'M 34.5 2.006137847900391 L 1.728530883789062 59 L 67.27146911621094 59 L 34.5 2.006137847900391 M 34.5 0 L 69 60 L 0 60 L 34.5 0 Z'
                            }
                        ]
                    },
                    {
                        tag: 'g',
                        attrs: {
                            fill: 'none',
                            stroke: EColors.White,
                            strokeWidth: 5,
                            transform: 'translate(962 312)'
                        },
                        value: [
                            {
                                tag: 'circle',
                                attrs: { stroke: 'none' },
                                fill: 'none',
                                value: {
                                    cx: 78.5,
                                    cy: 78.5,
                                    r: 78.5
                                }
                            },
                            {
                                tag: 'circle',
                                attrs: {
                                    fill: 'none'
                                },
                                value: {
                                    cx: 78.5,
                                    cy: 78.5,
                                    r: 76
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    },
    'video-pause-button': {
        viewBox: '0 0 271.953 271.953',
        items: [
            {
                tag: 'path',
                fill: EColors.White,
                value: 'M135.977,271.953c75.097,0,135.977-60.879,135.977-135.977S211.074,0,135.977,0S0,60.879,0,135.977    S60.879,271.953,135.977,271.953z M135.977,21.756c62.979,0,114.22,51.241,114.22,114.22s-51.241,114.22-114.22,114.22    s-114.22-51.241-114.22-114.22S72.992,21.756,135.977,21.756z'
            },
            {
                tag: 'path',
                fill: EColors.White,
                value: 'M110.707,200.114c7.511,0,13.598-6.086,13.598-13.598V83.174c0-7.511-6.086-13.598-13.598-13.598    c-7.511,0-13.598,6.086-13.598,13.598v103.342C97.109,194.028,103.195,200.114,110.707,200.114z'
            },
            {
                tag: 'path',
                fill: EColors.White,
                value: 'M165.097,200.114c7.511,0,13.598-6.086,13.598-13.598V83.174c0-7.511-6.086-13.598-13.598-13.598    S151.5,75.663,151.5,83.174v103.342C151.5,194.028,157.586,200.114,165.097,200.114z'
            }
        ]
    },
    call: {
        viewBox: '0 0 12 12',
        items: [
            {
                tag: 'path',
                value: 'M0.507672515,1.68409357 C0.580561404,1.42753216 0.749871345,1.20909942 0.980140351,1.07450292 L1.99396491,0.466292398 C2.13391813,0.382081871 2.31534503,0.422877193 2.40575439,0.558900585 L3.28404678,1.87752047 L4.02119298,2.98315789 C4.10949708,3.11667836 4.08049123,3.29560234 3.95452632,3.39436257 L3.04690058,4.10037427 C2.77069006,4.31157895 2.69183626,4.69375439 2.86187135,4.99702924 L2.93391813,5.12797661 C3.18902924,5.59585965 3.50619883,6.17791813 4.66414035,7.33567251 C5.82208187,8.49340351 6.40395322,8.81059649 6.87162573,9.06568421 L7.00278363,9.13794152 C7.30605848,9.30797661 7.68823392,9.22912281 7.8994386,8.95291228 L8.60545029,8.04528655 C8.70425731,7.9194152 8.88311111,7.89040936 9.01665497,7.97861988 L11.4409123,9.59546199 C11.5770292,9.68580117 11.617848,9.86732164 11.5335205,10.0072515 L10.9253099,11.021076 C10.790924,11.2510643 10.5727485,11.4201637 10.3165146,11.4929357 C9.08851462,11.8300819 6.94308772,11.5508304 3.69644444,8.30416374 C0.449777778,5.05752047 0.170526316,2.91230409 0.507672515,1.68409357 Z M9.48334503,11.9999867 C9.80014035,12.0013333 10.1156725,11.9600936 10.4214971,11.8774035 C10.7773333,11.7776608 11.0806784,11.5439064 11.2678596,11.2252632 L11.8774503,10.2120468 C12.0716491,9.88945029 11.977614,9.47118129 11.6640702,9.26271345 L9.23960234,7.64587135 C8.93192982,7.44231579 8.51950877,7.50930994 8.29207018,7.79976608 L7.58584795,8.70778947 C7.49506433,8.82746199 7.33010526,8.86217544 7.19880702,8.78921637 L7.06446784,8.71518129 C6.6191345,8.47244444 6.06500585,8.17024561 4.9485848,7.0534269 C3.83216374,5.93660819 3.52935673,5.38208187 3.28664327,4.93754386 L3.21298246,4.80320468 C3.13904094,4.67192982 3.17309942,4.50624561 3.29281871,4.41476023 L4.20025731,3.70874854 C4.49059649,3.48126316 4.55763743,3.06895906 4.35433918,2.76119298 L2.73749708,0.336725146 C2.52912281,0.0233450292 2.11111111,-0.0707368421 1.7885614,0.123157895 L0.774736842,0.732163743 C0.456187135,0.919415205 0.222479532,1.22273684 0.122619883,1.57850292 C-0.242479532,2.90870175 0.0321871345,5.20442105 3.4139883,8.58661988 C6.10414035,11.2765614 8.10683041,11.9999867 9.48334503,11.9999867 L9.48334503,11.9999867 Z'
            },
            {
                tag: 'path',
                value: 'M7.14999385,2.29998945 C8.55766493,2.30157149 9.69843028,3.44232595 9.69999473,4.85000527 C9.69999473,4.9328513 9.76714303,5 9.84998857,5 C9.93283412,5 10,4.9328513 10,4.85000527 C9.99825977,3.27670421 8.7232857,2.00174024 7.14999385,2 C7.06714831,2 7,2.0671487 7,2.14999473 C7,2.23284075 7.06714831,2.29998945 7.14999385,2.29998945'
            },
            {
                tag: 'path',
                value: 'M7.21427675,2.42855708 C8.51545615,2.43011401 9.56988959,3.48453116 9.5714214,4.78572146 C9.5714214,4.90407313 9.66734747,5 9.78569814,5 C9.90404882,5 10,4.90407313 10,4.78572146 C9.99821708,3.24795339 8.75205705,2.00175782 7.21427675,2 C7.09592607,2 7,2.09592687 7,2.21427854 C7,2.3326302 7.09592607,2.42855708 7.21427675,2.42855708'
            },
            {
                tag: 'path',
                value: 'M7.24998901,3.49998535 C7.94001494,3.50083497 8.49917237,4.06000059 8.5,4.75000732 C8.5,4.88808484 8.61190619,5 8.74998169,5 C8.88805719,5 9,4.88808484 9,4.75000732 C8.99888672,3.78396273 8.21604875,3.00108399 7.24998901,3 C7.11191352,3 7,3.11191516 7,3.24999268 C7,3.3880702 7.11191352,3.49998535 7.24998901,3.49998535'
            }
        ]
    },
    mail: {
        viewBox: '0 0 14 9',
        items: [
            {
                tag: 'path',
                value: 'M0.987355469,0.519195275 L13.0126172,0.519195275 L7.413,4.5692401 C7.31232031,4.64312081 7.15774609,4.6893424 6.99997266,4.68866438 C6.84219922,4.6893424 6.68767969,4.64312081 6.58697266,4.5692401 L0.987355469,0.519195275 Z M13.4615195,8.10881717 L10.4400352,4.50967674 C10.3465195,4.39822286 10.1769063,4.38108422 10.0614883,4.47125982 C9.94571484,4.56143543 9.92794141,4.72501714 10.0214844,4.83647102 L13.0727734,8.47110162 C13.0758359,8.47474028 13.079582,8.47750883 13.0828359,8.48080472 L0.917164062,8.48080472 C0.920390625,8.47735063 0.924164062,8.47474028 0.927226562,8.47110162 L3.97851562,4.83647102 C4.07203125,4.72501714 4.05428516,4.56162 3.93851172,4.47125982 C3.82290234,4.38111058 3.65345312,4.39822286 3.55996484,4.50967674 L0.538480469,8.10881717 L0.538480469,0.843721985 L6.26409766,4.98460159 C6.47932031,5.13916574 6.74116406,5.20716659 6.99997266,5.20785213 C7.25845313,5.20732479 7.52048828,5.13932395 7.735875,4.98460159 L13.4615195,0.843721985 L13.4615195,8.10881717 L13.4615195,8.10881717 Z M13.2820352,0 L0.717964844,0 C0.323066406,0 0,0.311527712 0,0.69232189 L0,8.30770448 C0,8.68844592 0.323066406,9 0.717964844,9 L13.2820352,9 C13.6769063,9 14,8.68847229 14,8.30770448 L14,0.69232189 C14,0.311527712 13.6769336,0 13.2820352,0 L13.2820352,0 Z'
            }
        ]
    },
    firstStep: {
        viewBox: '113 14 13 58',
        items: [
            {
                tag: 'path',
                value: 'M122.939252,67 C122.777259,64.56 122.676012,62.49 122.635514,60.79 C122.595016,59.09 122.574766,57.4 122.574766,55.72 L122.574766,30.22 C122.574766,28.58 122.595016,26.94 122.635514,25.3 C122.676012,23.66 122.797508,21.56 123,19 L119.233645,19 C118.504673,22.28 117.370717,25.54 115.831776,28.78 C114.292835,32.02 112.34891,35.22 110,38.38 L112.61215,39.64 C114.394081,36.12 115.852025,32.84 116.985981,29.8 C118.119938,26.76 118.929907,23.74 119.415888,20.74 L119.415888,55.72 C119.415888,57.4 119.385514,59.09 119.324766,60.79 C119.264019,62.49 119.172897,64.56 119.051402,67 L122.939252,67 Z'
            }
        ]
    },
    secondStep: {
        viewBox: '104 14 29 58',
        items: [
            {
                tag: 'path',
                value: 'M132.164557,65 L134,61.1365854 C132.356841,61.601626 130.766124,61.9504065 129.227848,62.1829268 C127.689572,62.4154472 126.142556,62.5764228 124.586799,62.6658537 C123.031043,62.7552846 121.326703,62.8 119.473779,62.8 L106.415913,62.8 C107.604581,60.403252 108.898131,58.3284553 110.296564,56.5756098 C111.694997,54.8227642 113.075949,53.3471545 114.439421,52.1487805 C115.802893,50.9504065 117.498493,49.6357724 119.526221,48.204878 L120.889693,47.2390244 C121.344183,46.9170732 121.798674,46.6130081 122.253165,46.3268293 C122.393008,46.1837398 122.515371,46.0943089 122.620253,46.0585366 C124.752863,44.4845528 126.500904,43.0804878 127.864376,41.8463415 C129.227848,40.6121951 130.372815,39.199187 131.299277,37.6073171 C132.225738,36.0154472 132.688969,34.2357724 132.688969,32.2682927 C132.688969,30.0146341 132.112116,28.0382114 130.958409,26.3390244 C129.804702,24.6398374 128.222725,23.3252033 126.212477,22.395122 C124.20223,21.4650407 121.938517,21 119.421338,21 C116.93912,21 114.719108,21.4382114 112.761302,22.3146341 C110.803496,23.1910569 109.26522,24.3804878 108.146474,25.8829268 C107.027728,27.3853659 106.468354,29.0308943 106.468354,30.8195122 C106.468354,32.9300813 107.010247,34.7634146 108.094033,36.3195122 C109.177818,37.8756098 110.663653,39.1902439 112.551537,40.2634146 L114.596745,37.5268293 C112.848704,36.8113821 111.441531,35.899187 110.375226,34.7902439 C109.308921,33.6813008 108.775769,32.2146341 108.775769,30.3902439 C108.775769,28.8162602 109.212779,27.3585366 110.086799,26.0170732 C110.96082,24.6756098 112.193189,23.6113821 113.783906,22.8243902 C115.374623,22.0373984 117.183846,21.6439024 119.211573,21.6439024 C122.358047,21.6439024 124.857746,22.5918699 126.710669,24.4878049 C128.563593,26.3837398 129.490054,28.8699187 129.490054,31.9463415 C129.490054,33.8422764 129.105485,35.5593496 128.336347,37.097561 C127.567209,38.6357724 126.570826,40.0398374 125.347197,41.3097561 C124.123568,42.5796748 122.48041,44.0552846 120.417722,45.7365854 L119.001808,46.8634146 C116.729355,48.7593496 114.841471,50.4406504 113.338156,51.9073171 C111.83484,53.3739837 110.331525,55.198374 108.82821,57.3804878 C107.324895,59.5626016 106.048825,62.102439 105,65 L132.164557,65 Z'
            }
        ]
    },
    thirdStep: {
        viewBox: '105 14 29 58',
        items: [
            {
                tag: 'path',
                value: 'M119.761733,65 C122.762936,65 125.327918,64.4017857 127.456679,63.2053571 C129.585439,62.0089286 131.208183,60.4017857 132.32491,58.3839286 C133.441637,56.3660714 134,54.1428571 134,51.7142857 C134,48.9642857 133.363117,46.7142857 132.08935,44.9642857 C130.815584,43.2142857 129.070698,42.0089286 126.854693,41.3482143 C124.884911,40.7609127 122.701434,40.6180556 120.304263,40.9196429 L120.12704,40.943956 L120.610911,40.7105655 C122.163859,39.9494048 123.559767,39.1631324 124.798636,38.3517485 L125.205776,38.0803571 C126.811071,36.9910714 128.145909,35.6607143 129.210289,34.0892857 C130.274669,32.5178571 130.806859,30.6964286 130.806859,28.625 C130.806859,27.0535714 130.422984,25.6160714 129.655235,24.3125 C128.887485,23.0089286 127.762034,21.9642857 126.278881,21.1785714 C124.795728,20.3928571 122.989771,20 120.861011,20 C117.51083,20 114.745187,20.9017857 112.564079,22.7053571 C110.382972,24.5089286 108.611913,26.7142857 107.250903,29.3214286 L107.250903,29.3214286 L110.287004,30.7678571 C111.333935,27.8035714 112.651324,25.375 114.23917,23.4821429 C115.827016,21.5892857 118.016847,20.6428571 120.808664,20.6428571 C123.251504,20.6428571 125.031288,21.375 126.148014,22.8392857 C127.264741,24.3035714 127.823105,26.0535714 127.823105,28.0892857 C127.823105,30.9821429 127.037906,33.4732143 125.467509,35.5625 C123.897112,37.6517857 121.262335,39.6071429 117.563177,41.4285714 L117.563177,41.4285714 L117.720217,42.125 C120.826113,41.4464286 123.364922,41.4732143 125.336643,42.2053571 C127.308363,42.9375 128.730445,44.1428571 129.602888,45.8214286 C130.475331,47.5 130.911552,49.4642857 130.911552,51.7142857 C130.911552,53.9285714 130.484055,55.9732143 129.629061,57.8482143 C128.774067,59.7232143 127.456679,61.2142857 125.676895,62.3214286 C123.897112,63.4285714 121.716005,63.9821429 119.133574,63.9821429 C116.725632,63.9821429 114.5358,63.5 112.564079,62.5357143 C110.592359,61.5714286 108.995788,60.1339286 107.774368,58.2232143 C106.552948,56.3125 105.837545,54.0178571 105.628159,51.3392857 L105.628159,51.3392857 L105,51.3392857 C105.348977,55.6607143 106.823406,59.0178571 109.423285,61.4107143 C112.023165,63.8035714 115.469314,65 119.761733,65 Z'
            }
        ]
    },
    close: {
        viewBox: '0 0 512.001 512.001',
        items: [
            {
                tag: 'path',
                value: 'M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717 L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859 c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287 l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285 L284.286,256.002z'
            }
        ]
    },
    checkmark: {
        viewBox: '0 0 512 512',
        items: [
            {
                tag: 'path',
                value: 'M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7C514.5,101.703,514.499,85.494,504.502,75.496z'
            }
        ]
    },
    starFilled: {
        viewBox: '0 0 20 18',
        items: [
            {
                tag: 'path',
                value: 'M10.2999 0L12.5226 6.84073H19.7154L13.8963 11.0685L16.119 17.9093L10.2999 13.6815L4.48083 17.9093L6.70352 11.0685L0.884443 6.84073H8.07721L10.2999 0Z'
            }
        ]
    },
    starEmpty: {
        viewBox: '0 0 20 18',
        items: [
            {
                tag: 'path',
                value: 'M10.1 1.61804L11.8471 6.99524L11.9594 7.34073H12.3226H17.9766L13.4024 10.664L13.1086 10.8776L13.2208 11.223L14.968 16.6003L10.3938 13.277L10.1 13.0634L9.80606 13.277L5.23193 16.6003L6.97909 11.223L7.09135 10.8776L6.79746 10.664L2.22333 7.34073H7.87726H8.24053L8.35279 6.99524L10.1 1.61804Z'
            }
        ]
    },
    edit: {
        viewBox: '0 0 37 34',
        items: [
            {
                tag: 'path',
                value: 'M19.5357 7.39241L23.3262 3.96765H0V34.0002H30.0325V15.2957L25.9504 19.2474V30.8389H3.49894V7.39241H19.5357Z'
            },
            {
                tag: 'path',
                value: 'M18.0206 22.7328L12.9851 17.4179L26.395 4.61079L31.4692 10.086L18.0206 22.7328Z'
            },
            {
                tag: 'path',
                value: 'M16.3975 24.414L11.6032 18.7862L10.0234 25.5783L16.3975 24.414Z'
            },
            {
                tag: 'path',
                value: 'M32.7869 8.77291L27.8081 3.47372L30.9146 0.554964C31.6481 -0.134291 32.1901 0.12139 32.5251 0.478411L35.9781 4.15348C36.6946 4.89891 36.2082 5.63823 35.8933 5.85438L32.7869 8.77291Z'
            }
        ]
    },
    delete: {
        viewBox: '0 0 36 37',
        items: [
            // stroke-width="4" stroke-miterlimit="10"
            {
                tag: 'path',
                value: 'M4.50031 9.07588V31.7779C4.50031 31.7779 4.41446 34.9509 7.11872 34.9509C9.28642 34.9509 28.1304 35 28.1304 35C28.1304 35 31.5 35 31.5 32.0396C31.5 30.1586 31.5 9.01045 31.5 9.01045C31.5 9.01045 4.50031 8.96138 4.50031 9.07588Z',
                fill: 'transparent',
                attrs: {
                    // stroke-width="4" stroke-miterlimit="10"
                    strokeWidth: 4,
                    strokeMiterlimit: 10
                }
            },
            { tag: 'path', value: 'M36 7H0V11H36V7Z' },
            {
                tag: 'path',
                value: 'M10.125 13L10.125 31L12.375 31L12.375 13L10.125 13Z'
            },
            {
                tag: 'path',
                value: 'M16.875 13L16.875 31L19.125 31L19.125 13L16.875 13Z'
            },
            {
                tag: 'path',
                value: 'M23.625 13L23.625 31L25.875 31L25.875 13L23.625 13Z'
            },
            {
                tag: 'path',
                fill: 'transparent',
                value: 'M10.4517 7.55482C10.4517 7.55482 11.4793 2.02123 17.6208 2.02123C17.6208 2.02123 24.374 1.34364 25.5484 7.64516',
                attrs: {
                    // stroke-width="4" stroke-miterlimit="10"
                    strokeWidth: 4,
                    strokeMiterlimit: 10
                }
            }
        ]
    },
    dragIndicator: {
        viewBox: '0 0 24 24',
        items: [
            {
                tag: 'path',
                value: 'M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
            }
        ]
    },
    profile: {
        viewBox: '0 0 422 422',
        items: [
            {
                tag: 'circle',
                value: {
                    cx: '211',
                    cy: '211',
                    r: '201.3'
                },
                fill: 'transparent',
                attrs: {
                    stroke: '#A78E52',
                    strokeWidth: '8px',
                    strokeMiterlimit: 10
                }
            },
            {
                tag: 'circle',
                value: {
                    cx: '210.5',
                    cy: '181.5',
                    r: '57.5'
                },
                fill: 'transparent',
                attrs: {
                    stroke: '#A78E52',
                    strokeWidth: '8px',
                    strokeMiterlimit: 10
                }
            },
            {
                tag: 'path',
                value: 'M61.4,345.7c2.3-21.8,19.3-37.6,37.8-58.8s46.8-20.2,46.8-20.2s128.8,0,128.8,0s28.4-1.1,46.8,20.2c18.5,21.3,34.8,39.1,37.1,60.9',
                fill: 'none',
                attrs: {
                    stroke: '#A78E52',
                    strokeWidth: '8px',
                    strokeMiterlimit: 10
                }
            }
        ]
    },
    warning: {
        viewBox: '0 0 30 30',
        items: [
            {
                tag: 'path',
                value: 'M0 30H30L15 0L0 30ZM16.3636 25.2632H13.6364V22.1053H16.3636V25.2632ZM16.3636 18.9474H13.6364V12.6316H16.3636V18.9474Z',
                fill: '#BE5353'
            }
        ]
    },
    cup: {
        viewBox: '0 0 329.013 329.013',
        items: [
            {
                tag: 'path',
                value: 'M112.739,113.054c1.027,0.7,2.232,1.07,3.486,1.07h0.015c3.424,0,6.209-2.784,6.209-6.206c0-0.594-0.083-1.179-0.247-1.746   c-3.575-15.656-1.881-28.265,5.034-37.478c8.149-10.857,11.758-24.788,9.655-37.264c-1.857-11.056-7.801-20.246-17.184-26.571   c-2.077-1.405-4.932-1.394-7.003,0.031c-2.112,1.456-3.103,4.014-2.521,6.531c3.86,16.472,0.35,26.907-8.453,42.743   c-5.482,9.86-7.721,20.937-6.305,31.189C97.029,96.947,103.025,106.532,112.739,113.054z',
                fill: '#BE5353'
            },
            {
                tag: 'path',
                value: 'M163.669,110.396c0.972,0.666,2.108,1.018,3.285,1.018h0.008c3.221,0,5.842-2.622,5.842-5.844   c0-0.547-0.076-1.088-0.228-1.614c-2.711-11.915-1.443-21.478,3.768-28.423c6.525-8.689,9.414-19.853,7.728-29.861   c-1.497-8.906-6.286-16.311-13.847-21.411c-1.946-1.314-4.581-1.334-6.599,0.04c-1.965,1.363-2.908,3.84-2.354,6.134   c2.942,12.548,0.247,20.534-6.505,32.676c-4.387,7.891-6.176,16.761-5.039,24.974C151.018,97.427,155.851,105.151,163.669,110.396z',
                fill: '#BE5353'
            },
            {
                tag: 'path',
                value: 'M323.73,148.029c-3.87-4.556-9.403-7.065-15.581-7.065h-28.652c0.298-4.912-0.606-11.039-4.108-15.162   c-2.589-3.048-6.278-4.659-10.669-4.659H16.389c-6.5,0-10.245,2.799-12.241,5.147c-4.089,4.808-4.652,12.008-3.817,17.143   c6.84,42.023,21.617,80.197,41.611,107.489c14.797,20.199,32.133,34.593,51.817,43.11H24.588c-8.593,0-15.583,6.991-15.583,15.583   s6.991,15.583,15.583,15.583h230.381c8.593,0,15.584-6.991,15.584-15.583s-6.991-15.583-15.584-15.583h-68.806   c16.21-6.979,30.778-17.913,43.604-32.749c21.998-1.884,44.091-12.389,62.912-30.063c19.245-18.071,32.363-41.139,35.993-63.286   C329.127,165.163,330.112,155.541,323.73,148.029z M255.23,222.011c8.363-17.15,14.22-34.841,18.313-51.047h23.638   C291.181,190.207,275.035,210.463,255.23,222.011z',
                fill: '#BE5353'
            }
        ]
    },
    tick: {
        viewBox: '0 0 16 18',
        items: [
            {
                tag: 'path',
                value: 'M1 11.3125L4.73333 16L15 1',
                fill: 'none',
                attrs: {
                    stroke: EColors.White
                }
            }
        ]
    },
    'plus-in-circle': {
        viewBox: '10 10 17 18',
        items: [
            {
                tag: 'circle',
                value: {
                    cx: '18.5601',
                    cy: '19.2029',
                    r: '6.86085',
                    transform: 'rotate(-45 18.5601 19.2029)'
                },
                fill: EColors.Gold
            },
            {
                tag: 'path',
                value: 'M19.24 15.1683L19.24 18.5163L22.516 18.5163L22.516 19.6503L19.24 19.6503L19.24 22.9983L18.178 22.9983L18.178 19.6503L14.884 19.6503L14.884 18.5163L18.178 18.5163L18.178 15.1683L19.24 15.1683Z',
                fill: EColors.White
            }
        ]
    }
};

// <svg
//   width="36"
//   height="37"
//   viewBox="0 0 36 37"
//   fill="none"
//   xmlns="http://www.w3.org/2000/svg"
// >
//   <path
//     d="M4.50031 9.07588V31.7779C4.50031 31.7779 4.41446 34.9509 7.11872 34.9509C9.28642 34.9509 28.1304 35 28.1304 35C28.1304 35 31.5 35 31.5 32.0396C31.5 30.1586 31.5 9.01045 31.5 9.01045C31.5 9.01045 4.50031 8.96138 4.50031 9.07588Z"
//     stroke="white"
//     stroke-width="4"
//     stroke-miterlimit="10"
//   />
//   <path d="M36 7H0V11H36V7Z" fill="white" />
//   <path d="M10.125 13L10.125 31L12.375 31L12.375 13L10.125 13Z" fill="white" />
//   <path d="M16.875 13L16.875 31L19.125 31L19.125 13L16.875 13Z" fill="white" />
//   <path d="M23.625 13L23.625 31L25.875 31L25.875 13L23.625 13Z" fill="white" />
//   <path
//     d="M10.4517 7.55482C10.4517 7.55482 11.4793 2.02123 17.6208 2.02123C17.6208 2.02123 24.374 1.34364 25.5484 7.64516"
//     stroke="white"
//     stroke-width="4"
//     stroke-miterlimit="10"
//   />
// </svg>;
